import React from 'react'
import { useParams } from 'react-router-dom'
import { withUserStore } from '../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from './PageView'
import Lex from '../Shared/Lex'
import CommentThread from './CommentThread/CommentThread';
// import {withTagsApi} from "../../apis/tags_api"
import PageProvider from '../../modules/PageProvider'

const Tasks = ({ userStore }) => {
  const form = {}
  const { priorityId } = useParams()

  const page = {
    clickUrl: () => 'goals',
    formName: () => userStore.lex.task,
    recordType: () => 'tasks',
    pageHeader: () => <h3 className="inline-block"><Lex term="task" plural /></h3>,
    newRecord: () => {
      return { name: '', description: '', priorityId }
    },
    records: () => {
      return (userStore.getRecords('tasks') || []).filter(t => t && t.name).sort((a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    },
    filterRecords: (s) => {
      return !priorityId || priorityId === s.priorityId
    },
    formFields: (record) => {
      record ||= { name: '', description: '', teamId: null, priorityId: priorityId }

      return <div>
        <Label><Lex term="name" /></Label><Input innerRef={el => form.name = el} defaultValue={record.name} /> <br />
        <Label><Lex term="description" /></Label><Input innerRef={el => form.description = el} defaultValue={record.description} />
        <br />
        <Label><Lex term="team" /></Label><Input type="select" innerRef={el => form.teamId = el} defaultValue={record.teamId}>
          {(userStore.getRecords('teams') || []).filter(t => t && t.name).map((t, index) => <option key={index} value={t.id}>{t.name}</option>)}
        </Input>
        <Label><Lex term="priority" /></Label><Input
          type="select" innerRef={el => form.priorityId = el}
          defaultValue={record.priorityId}
        >
          {(userStore.getRecords('priorities') || []).filter(p => p && p.name).map((p, index) => <option
            key={index}
            value={p.id}
          >{p.name}
          </option>)}
        </Input>
      </div>
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      record.teamId = form.teamId.value
      record.priorityId = form.priorityId.value
      if (record.id) { 
        userStore.update(record, 'task', record) 
      } else { 
        userStore.create('task', record) 
      }
      return true
    },
    destroy: (record) => userStore.destroy(record, 'task'),
    showJournal: true,
    showComment: true,
    commentThreadPageProvider: PageProvider({
      formFields: (record) => <CommentThread commentable={record}>{record.name}</CommentThread>,
      record: () => { return {} }
    })
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Tasks)
